<template>
    <div class="bp-deadline" :class="showUrgency ? urgencyClass : ''">
        <span v-if="days !== null">{{ days }} {{ days === 1 ? 'Tag' : 'Tage' }}</span>
        <span v-else>-</span>
    </div>
</template>

<script>
import Cell from './cell';
import moment from 'moment';

export default {
    mixins: [Cell],

    props: {
        showUrgency: { type: Boolean, default: true },
    },

    computed: {
        days() {
            if (!this.value || !this.value.date) {
                return null;
            }

            const date = moment(this.value.date, 'DD.MM.YYYY');
            if (!date.isValid()) {
                return null;
            }

            return moment().startOf('day').diff(date.startOf('day'), 'days');
        },

        urgencyClass() {
            if (this.days === null) return '';
            if (this.days > 14) return 'is-red';
            if (this.days > 7) return 'is-yellow';
            return '';
        },
    },
};
</script>
